import React, { useState } from "react";
import "./Forgot.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import chevronleft from "../../../images/chevronleft.svg";
import { useDispatch, useSelector } from "react-redux";
import { userForgotPasswordApi, userOtpVerificationApi } from "../../../Services/Login/LoginApi/loginApi";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotComp() {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.userLogin);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Disable the button

    try {
      const res = await dispatch(
        userForgotPasswordApi({
          otp_type: "FORGOT_PASSWORD_OTP",
          email: email,
        })
      );

      if (res?.payload?.status === 200) {
        toast.success("Email sent successfully");
        setTimeout(() => {
          navigate("/confirm-account-otp");
          localStorage.setItem("fp_id", res?.payload?.data?.user_id);
          localStorage.setItem("fp_email", email)
        }, 1000);
      } else {
        toast.error(res?.payload?.message || "Failed to send email");
      }
    } catch (error) {
      toast.error("An error occurred while sending the email.");
      console.error("Error during email submission:", error);
    } finally {
      setIsSubmitting(false); // Re-enable the button
    }
  };


  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one forgot-pw-section">
        <div className="container-fluid p-0">
          <div className="row m-0 row-forgotpw">
            <div className="col-md-6">
              <div className="banner-contents">
                <div className="banner-image">
                  {/* <img src={banner_img} alt="banner-image"></img> */}
                  <div className="text-overlay">
                    <h5>Welcome Back!</h5>
                    <p>
                      Elevate your business insights with precision. Log in to
                      discover and refine your Ideal Customer Profiles
                      effortlessly.
                    </p>
                  </div>
                </div>

              </div>
            </div>
            <div className="col-md-6 forgotpw-box">
              <div className="login-right-block">
                <div className="login-logoimg text-center forgotpw-block">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
                <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div>
              <div className="forgt-pw-block">
                <div className="login-information">
                  <h1 className="text-center m-0">Forgot Password</h1>
                  <p className="pw-texts text-center mt-1">
                    Please enter the email address associated with your account.
                  </p>
                  <div className="form-login text-left">
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-email">
                        Business Email <span>*</span>
                      </InputLabel>
                      <Input
                        className="email-input-box"
                        id="standard-adornment-email"
                        type="email"
                        placeholder="Email"
                        onChange={(event) => setEmail(event.target.value)}
                      />
                    </div>
                    <div className="btn-orange">
                      <Button
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        variant="contained"
                      >
                        {isSubmitting ? "Sending..." : "Send Reset Code"}
                      </Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      <p>
                        Need Help? <a href="">Click Here</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <ToastContainer />
    </>
  );
}

export default ForgotComp;
